<template>
  <div class="investors-fs">
    <p class="indent">AALCOMET AD è una società pubblica le cui azioni sono quotate alla Borsa bulgara. Secondo la legge sull'offerta pubblica di titoli, la società rivela regolarmente informazioni finanziarie e di altro tipo alla Commissione di vigilanza finanziaria, alla Borsa bulgara ed al pubblico.</p>
    <p class="indent">Rapporti finanziari trimestrali ed annuali sono predisposti secondo gli standard contabili internazionali e verificati da revisori indipendenti.</p>
    <p class="indent">Qui è possibile scaricare i nostri ultimi resoconti  finanziari.</p>
    <p>
      <a href="/static/files/Alcomet-AD-2017-financial-statements.doc" target="_blank">Alcomet AD 2017 - Financial statements</a>
    </p>
    <p>
      <a href="/static/files/Alcomet-AD-2016-Financial-statements.pdf" target="_blank">Alcomet AD 2016 - Financial statements</a>
    </p>
    <p>
      <a href="/static/files/Alcomet-AD-2015-Financial-statements.pdf" target="_blank">Alcomet AD 2015 - Financial statements</a>
    </p>
    <p>
      <a href="/static/files/Alcomet-AD-2014-ENG-financial-statements.pdf" target="_blank">Alcomet AD 2014 - Financial statements</a>
    </p>
    <p>
      <a href="/static/files/Alcomet-AD-2013-ENG-f.pdf" target="_blank">Management report and Financial statements for 2013</a>
    </p>
    <p>
      <a href="/static/files/Alcomet-AD-2012-ENG-FS.pdf" target="_blank">Management report for 2012</a>
    </p>
    <p>
      <a href="/static/files/Alcomet-AD_Man.Report-2012-EN.pdf" target="_blank">Financial statements for 2012</a>
    </p>
    <p>
      <a href="/static/files/Alcomet-AD-2011-Management-Report-EN.docx">Management Report for 2011</a>
    </p>
    <p>
      <a href="/static/files/Alcomet-AD-2011-FS_AR_ENG.docx">Financial statements for 2011</a>
    </p>
    <app-share-button></app-share-button>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.investors-fs > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .investors-fs > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investors/FinancialStatements.vue